import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CodificationService } from './../../common-services/codification.service';
import { Codification } from './../../model/Codification';

@Component({
  selector: 'code-display',
  templateUrl: './code-display.component.html',
  styleUrls: ['./code-display.component.less'],
  animations: [
    trigger("bottomIn", [
      transition(':enter', [
        style({ 'bottom': "-25vh" }),
        animate('0.4s 0.1s ease-in-out', style({ 'bottom': "0", "height": "24vh" })),
        animate('0.2s ease-in-out', style({ height: "22vh" })),
      ]),
      transition(':leave', [
        animate('0.2s ease-in-out', style({ 'bottom': "0", "height": "24vh" })),
        animate('0.4s ease-in-out', style({ 'bottom': "-25vh" })),
      ])
    ]),
  ]

})
export class CodeDisplayComponent implements OnInit {


  public keypadVisible: boolean = true;
  private _digits: number;
  public get digits(): number {
    return this._digits;
  }
  @Input()
  public set digits(v: number) {
    this._digits = v;
    this.code = [];
    for (let index = 0; index < v; index++) {
      this.code.push(null);

    }
  }
  public codification: Codification = new Codification("color", "assets/images/color.png", 7);
  public code: number[] = [];
  @Input()
  public current: number[] = [];

  @Output()
  public onCurrentChange: EventEmitter<number[]> = new EventEmitter<number[]>();

  private _type: string = "numbers";
  public get type(): string {
    return this._type;
  }
  @Input()
  public set type(v: string) {
    this._type = v;
    this.codificationService.getCodification(v).then(r => {
      this.codification = r;
    });
  }


  public reset() {
    this.current.length = 0;
    this.currentSelected = 0;
  }
  public currentSelected: number = 0;
  constructor(private codificationService: CodificationService) {
    this.codificationService.getCodification(this.type).then(r => {
      this.codification = r;
    });
  }
  public hideKeyboard() {
    if (this.keypadVisible) {
      this.keypadVisible = false;
    }
  }
  public showKeyboard() {
    if (!this.keypadVisible)
      this.keypadVisible = true;
  }

  ngOnInit(): void {
  }


  public hasDuplicates(i: number) {
    return this.current.filter(e => e != undefined && this.current[i] == e).length > 1
  }

  public select(i: number) {
    this.currentSelected = i;
    this.showKeyboard();
    //event.stopPropagation();
  }
  public setChoice(i: number) {
    if (this.currentSelected >= this.digits) return;
    this.current[this.currentSelected] = i;
    if (this.currentSelected < this.digits)
      this.currentSelected++;

  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) { 
    
    // Only Numbers 0-9
    if (/^\d+$/.test(event.key)) {
      this.setChoice(Number(event.key))
   
    }
  }
}
